import { format } from "date-fns"
import moment from "moment"
import React from "react"
import styled from "styled-components"
import branding from "../branding/branding"
import { DetailNavLink } from "../contentArea/detailPages/DetailNavLink"
import { useLanguageState } from "../globalStates/LanguageState"
import { device, DesktopVersionContainer } from "../utils/Device"
const germanLocale = require("date-fns/locale/de")

const EventLayoutRoot = styled.div`
    color: ${branding.mainInfoColor};
    padding: 25px 0;
    position: relative;

    @media ${device.tablet} {
        border-bottom: ${"1px solid " + branding.listDividerColor};
        border-top: ${"1px solid " + branding.listDividerColor};
    }
`

const EventLayoutTitle = styled.span`
    font-weight: bold;
    font-size: 18px;

    @media ${device.mobile} {
        font-size: 16px;
        margin-left: 15px;
    }
`

export const EventLogoDiv = styled(DetailNavLink)`
    width: 95px;
    height: 95px;
    background: white;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;

    @media (max-width: 1200px) {
        width: 80px;
        height: 80px;
    }

    @media ${device.mobile} {
        width: 95px;
        height: 95px;
        padding: 10px;
        margin-left: 15px;
    }
`

export const EventLogo = styled.img`
    object-fit: contain;
    margin: 0 20;
    height: 100%;
    width: 100%;
`

const EventDateRootArea = styled.div`
    display: flex;
    flex: 1;

    &.center-inside * {
        display: flex;
        justify-content: center;
    }

    @media ${device.mobile} {
        margin-top: 15%;
    }
`
const DescriptionRoot = styled(DetailNavLink)`
    font-family: ${branding.font1};
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    width: 100%;

    & .list-view {
        width: 60%;
    }
`
export const CompanyLogoImage = styled.img`
    object-fit: contain;
    height: 100%;
    width: 100%;
    margin: 0 auto;
`
export const EventNameDiv = styled(DetailNavLink)`
    font-size: 16px !important;
    font-weight: bold;
    color: ${branding.programSchedule.listViewTitleColor};

    @media ${device.mobile} {
        font-size: 14px !important;
    }
`

interface CompanyDetailsSectionProps {
    event: any
}

const EventLayout: React.FunctionComponent<CompanyDetailsSectionProps> = React.memo((props) => {
    const lang = useLanguageState().getLanguage()

    const getFormattedDate = (date: string) => {
        if (date)
            return format(moment(date).toDate(), branding.eventTiming.eventDaysFormatPatternEvtDetailPage, {
                locale: lang === "de" ? germanLocale : null,
            })
    }
    return (
        <>
            <EventLayoutRoot>
                <div style={{ marginBottom: "20px" }}>
                    <EventLayoutTitle>{branding.eventDateDetailPageContent.eventLayoutTitle}</EventLayoutTitle>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ width: "100px" }}>
                        <EventLogoDiv type="event" name={props.event.name} id={props.event.id}>
                            <EventLogo src={props.event.logo || "/branding/rsz_defaultgrey.png"} />
                        </EventLogoDiv>
                    </div>
                    <div className="d-flex" style={{ width: "100%", paddingRight: "10px", marginLeft: "25px" }}>
                        <EventDateRootArea>
                            <div>
                                <DesktopVersionContainer>
                                    {props.event.start && props.event.end && (
                                        <div style={{ fontSize: "12px", fontWeight: 400, marginBottom: "10px" }}>
                                            {getFormattedDate(props.event.start)} - {getFormattedDate(props.event.end)}
                                        </div>
                                    )}
                                </DesktopVersionContainer>
                                <EventNameDiv type="event" name={props.event.name} id={props.event.id}>
                                    {props.event.name}{" "}
                                </EventNameDiv>
                                <DescriptionRoot type="event" name={props.event.name} id={props.event.id}>
                                    <div style={{ fontSize: "12px", marginTop: "10px" }}>
                                        {" "}
                                        {lang === "de" ? props.event.descriptionShortDe : props.event.descriptionShort}{" "}
                                    </div>
                                </DescriptionRoot>
                            </div>
                        </EventDateRootArea>
                    </div>
                </div>
            </EventLayoutRoot>
        </>
    )
})

export default EventLayout
